import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ChevronLeft, ChevronRight, Lock, Mail, PhoneCall } from "lucide-react";

import { UIButton } from "../../../components/ui";
import messages from "../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";

import "./CompanyDeactivated.scss";

// No API returns the support contact: these are the design's values.
const SUPPORT_EMAIL = "support@yoram.com";
const SUPPORT_PHONE = "+966 11 234 5678";

/**
 * `/company/deactivated`: a user of a deactivated company signed in with valid credentials,
 * but the portal isn't opened. The only action is going back to the login page.
 */
const CompanyDeactivated = () => {
  const lang = useSelector((state) => state.locale.lang);
  const history = useHistory();
  const t = messages[lang].login.deactivatedAccount;
  const BackIcon = lang === "ar" ? ChevronRight : ChevronLeft;

  return (
    <div className="company-deactivated">
      <div className="company-deactivated__icon" aria-hidden>
        <Lock size={28} strokeWidth={2} absoluteStrokeWidth />
      </div>
      <div className="company-deactivated__text">
        <h1 className="company-deactivated__title">{t.title}</h1>
        <p className="company-deactivated__description">{t.description}</p>
      </div>
      <div className="company-deactivated__support">
        <p className="company-deactivated__support-title">{t.supportTitle}</p>
        <div className="company-deactivated__contact">
          <Mail size={18} strokeWidth={1.2} absoluteStrokeWidth aria-hidden />
          <span dir="ltr">{SUPPORT_EMAIL}</span>
        </div>
        <div className="company-deactivated__contact">
          <PhoneCall size={18} strokeWidth={1.3} absoluteStrokeWidth aria-hidden />
          <span dir="ltr">{SUPPORT_PHONE}</span>
        </div>
      </div>
      <UIButton
        type="button"
        variant="ghost"
        size="small"
        className="company-deactivated__back"
        startIcon={<BackIcon size={16} aria-hidden />}
        onClick={() => history.replace(ROUTE_PATHS.companyLogin)}
      >
        {t.backToSignIn}
      </UIButton>
    </div>
  );
};

export default CompanyDeactivated;
